<template>
  <atoms-card
    shadow="bordered"
    rounded="md"
    size="none"
    class="text-center md:max-w-1.5xl mx-auto"
  >
    <div class="p-4">
      <p class="text-xl font-bold mt-3 text-dark">
        {{ title }}
      </p>

      <!-- eslint-disable vue/no-v-html -->
      <div
        class="border-t border-t-gray-300 mt-4 pt-4 text-neutral-400"
        v-html="subtitle"
      >
      </div>

      <div class="mt-4 mx-auto mb-2">
        <atoms-cta
          v-for="(option, index) in options"
          :id="generateId(option.label)"
          :key="index"
          :to="option.link"
          size="large"
          rounded="standard"
          class="text-center mb-2 font-bold"
        >
          <span class="text-white text-lg">
            {{ option.label }}
          </span>
        </atoms-cta>
      </div>
    </div>
  </atoms-card>
</template>

<script setup>
defineOptions({
  name: 'InlineRate'
})

defineProps({
  title: {
    type: String,
    default: 'Select your amount and compare now'
  },

  subtitle: {
    type: String,
    default: '<p>Find a low repayment rate</p>'
  },

  options: {
    type: Array,
    default: () => ([])
  }
})

function generateId (str) {
  return `cta-inline-${str.toLowerCase().replace(/ /g, '')}`
}
</script>
